import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const ProofOfConclusionPage = lazy(() => import('../pages/ProofOfConclusionPage'));

const routes = [
  {
    path: Location.PROOF_OF_CONCLUSION,
    component: ProofOfConclusionPage,
    exact: true,
    accessDeniedDescription: 'ver comprovantes',
  },
];

export default routes;
